<template>
  <DxPopup @hidden="onHidden" :visible="showUserPop" :show-close-button="true" :show-title="true" :title="'User Select'" height="700px" width="1000px" container=".sys0020-main">
    <v-row no-gutters fill-height>
      <v-col cols="12" class="pa-0">
        <v-row no-gutters fill-height>
          <v-col cols="12" class="pa-0">
            <i-card-top class="d-md-flex"
              :useBtnList="[
                'btnSearch',
                'btnSelect'
              ]"
              @btnSearch="searchUsers()"
              @btnSelect="selectUsers()"
            >
              <template v-slot:body>
                <v-row no-gutters class="pa-2 pb-0">
                  <i-label :label="'User ID : '"/>
                  <v-col cols="2">
                    <v-text-field
                      v-model="userId"
                      dense 
                      outlined 
                      hide-details="auto"
                      clearable 
                    />
                  </v-col>

                  <i-label :label="'User Name : '" class="pl-2"/>
                  <v-col cols="2">
                    <v-text-field
                      v-model="userNm"
                      dense 
                      outlined 
                      hide-details="auto"
                      clearable 
                    />
                  </v-col>
                </v-row>
              </template>
            </i-card-top>
          </v-col>
        </v-row>
        
        <v-row no-gutters fill-height>
          <v-col cols="12" class="pa-0">
            <DxDataGrid
              id="users"
              :ref="usersListRef"
              :data-source="usersList"
              :remote-operations="false"
              :hover-state-enabled="true"
              :allow-column-resizing="true"
              :allow-column-reordering="true"
              :row-alternation-enabled="true"
              :show-borders="true"
              :width="grid.width"
              :show-row-lines="true"
              key-expr="id"
              :focused-row-enabled="true"
              :column-hiding-enabled="false"
            >
              <!-- <DxPager :show-page-size-selector="false"/> -->
              <!-- <DxPaging :enabled="true" :page-size="15" /> -->
              <DxPaging :enabled="true" />
              <DxColumn data-field="userId" :caption="$t('User ID')" width="auto" data-type="string" alignment="center"  :allow-editing="false" />
              <DxColumn data-field="userNm" :caption="$t('User Name')" width="auto" data-type="string" alignment="left" :allow-editing="false" />
              <DxColumn data-field="makerNm" :caption="$t('Maker Name')" width="auto" data-type="string" alignment="left" :allow-editing="false" />
              
              <DxSelection
                select-all-mode="allPages"
                show-check-boxes-mode="always"
                mode="multiple"
              />
            </DxDataGrid>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup'
import { DxDataGrid, DxColumn  } from 'devextreme-vue/data-grid'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'

import { getPopUsers } from '@/api/system/authManage'

export default {
  name: 'sys0200UserPop',
  mixins: [baseview, BaseDataGrid],
  props: {
    showUserPop: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  components: {
    DxPopup,
    DxDataGrid,
    DxColumn
  },
  data() {
    return {
      usersListRef: 'usersListRef',
      usersList: [],
      userId: '',
      userNm: ''
    }
  },
  computed: {
    usersInstance() {
      return this.GetDataGrid(this.usersListRef)
    },
  },
  watch: {
    'showUserPop': {
      handler(value, oldValue) {
        if(value) {
          this.init()
          this.searchUsers()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
      // this.usersInstance.option('defaultPaging', false)
      this.usersList = []
      this.userId = ''
      this.userNm = ''
    },
    searchUsers() {
      this.usersList = []
      this.usersInstance.clearSelection()

      const param = {
        sysId: this.$store.state.system.sysId,
        userId: this.userId ? this.userId : '',
        userNm: this.userNm ? this.userNm : ''
      }

      getPopUsers(param).then(res => {
        // console.log('res', res)

        this.usersList = res.list
      })
    },
    async selectUsers() {
      const selectedRows = await this.usersInstance.getSelectedRowsData()
      // console.log('selectedRows', selectedRows)

      if(selectedRows.length < 1) {
        this.vToastify(this.$t('SelectCheck'), 'warn')
        return
      }

      this.$emit('selected', selectedRows)
      this.$emit('update:showUserPop', false)
    },
    onHidden(e) {
      this.$emit('update:showUserPop', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.subTitle {
  font-weight: bold;
  color: black;
}

//.v-btn {
//    text-transform: unset !important;
//}
</style>